import { MoreVert as MoreVertIcon } from 'components/icons';
import { TableRowCallForActionButton } from 'components/buttons/CallForActionButton';
import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';
import { FormattedMessage } from 'react-intl';
import { t } from 'utils/getTranslations';

interface Props {
    matterId: number;
    isExcludedFromXR: boolean;
    isMatterEditable: boolean;
    onExcludeFromXR: (matterId: number) => void;
}

const ExperienceRecordActionButtons = ({
    matterId,
    isExcludedFromXR,
    isMatterEditable,
    onExcludeFromXR,
}: Props): JSX.Element => {
    const { openModal, closeModal } = useModal();

    const handleOpenExcludeModal = () =>
        openModal(
            <ConfirmationModal
                onCancel={closeModal}
                onConfirm={() => {
                    onExcludeFromXR(matterId);
                    closeModal();
                }}
                content={<FormattedMessage id="experience-records.list-page.actions.exclude-from-xr-confirmation" />}
            />,
            closeModal
        );

    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={
                    <TableRowCallForActionButton shape="rounded" aria-label={t('actions')}>
                        <MoreVertIcon />
                    </TableRowCallForActionButton>
                }
            />
            <DropdownMenuContent align="end" className="w-auto">
                <DropdownMenuItem onClick={handleOpenExcludeModal} disabled={isExcludedFromXR || !isMatterEditable}>
                    <FormattedMessage id="experience-records.list-page.actions.exclude-from-xr" />
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default ExperienceRecordActionButtons;
